/* HOLY SPIRIT - Cart reservation timer. Soft, session-based, decorative. */
(function () {
  var KEY = 'hs_cart_reserve_deadline';
  function deadline() {
    var v = sessionStorage.getItem(KEY);
    var now = Date.now();
    if (!v || isNaN(+v) || +v <= now) {
      v = now + 10 * 60 * 1000;
      try { sessionStorage.setItem(KEY, v); } catch (e) {}
    }
    return +v;
  }
  function tick() {
    var els = document.querySelectorAll('.hs-cart-timer__value');
    if (!els.length) return;
    var ms = Math.max(0, deadline() - Date.now());
    var m = Math.floor(ms / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    var txt = m + ':' + (s < 10 ? '0' : '') + s;
    for (var i = 0; i < els.length; i++) { els[i].textContent = txt; }
  }
  if (!window.__hsCartTimer) { window.__hsCartTimer = setInterval(tick, 1000); }
  tick();
})();
